import { SurveyTemporalFilterType } from '../Surveys/surveyInterface';

export interface FormInterface {
    id: string
    title?: string
    formGroups: FormGroup[]
    handleNextStep?: (formId: string) => void
}

export enum FormTypeEnum {
    TEXT = 'TEXT',
    NUMBER = 'NUMBER',
    TITLE = 'TITLE',
    EDIT_INPUT = 'EDIT_INPUT',
    TEXTAREA = 'TEXTAREA',
    RADIO_SELECT = 'RADIO_SELECT',
    CHECKBOX = 'CHECKBOX',
    SELECT_LIST = 'SELECT_LIST',
    MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
}

export type FormGroup = {
    id: string
    label: string
    placeholder?: string
    value: boolean | string | number | string[] | undefined
    onChange: (entry: any) => void
    type: FormTypeEnum
    choices?: {id: boolean | string | SurveyTemporalFilterType, label: string}[]
    display: boolean
    column?: number
    isOptional?: boolean
    information?: string
    disabled?: boolean
}
